/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.5.0.0 (NJsonSchema v10.1.15.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get awards. If not existing, get awards for default language.
     * @param lang (optional) Send language short code
     * @param page (optional) Send page number
     * @param limit (optional) Send limit per page
     * @return successful operation
     */
    getAwards(lang: string | undefined, page: number | undefined, limit: number | undefined): Promise<AwardResource> {
        let url_ = this.baseUrl + "/api/awards?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAwards(_response);
        });
    }

    protected processGetAwards(response: Response): Promise<AwardResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AwardResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AwardResource>(<any>null);
    }

    /**
     * Get page components. If not existing, get page components for default language.
     * @param lang (optional) Send language short code
     * @param slug Send page slug
     * @return successful operation
     */
    getPageComponents(lang: string | undefined, slug: string): Promise<PageComponent[]> {
        let url_ = this.baseUrl + "/api/page-components/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPageComponents(_response);
        });
    }

    protected processGetPageComponents(response: Response): Promise<PageComponent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PageComponent[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageComponent[]>(<any>null);
    }

    /**
     * Send contact message
     * @param body (optional) 
     * @return successful operation
     */
    contact(body: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContact(_response);
        });
    }

    protected processContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            return throwException("unprocessable entity", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get all available departments.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getAllDepartments(lang: string | undefined): Promise<Department[]> {
        let url_ = this.baseUrl + "/api/departments?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDepartments(_response);
        });
    }

    protected processGetAllDepartments(response: Response): Promise<Department[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Department[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department[]>(<any>null);
    }

    /**
     * Get distributors by country_code.
     * @param lang (optional) Send lang short code
     * @param country_code Send country code
     * @return successful operation
     */
    getDistributorsByCountryCode(lang: string | undefined, country_code: string): Promise<Distributor[]> {
        let url_ = this.baseUrl + "/api/distributors?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (country_code === undefined || country_code === null)
            throw new Error("The parameter 'country_code' must be defined and cannot be null.");
        else
            url_ += "country_code=" + encodeURIComponent("" + country_code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistributorsByCountryCode(_response);
        });
    }

    protected processGetDistributorsByCountryCode(response: Response): Promise<Distributor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Distributor[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Distributor[]>(<any>null);
    }

    /**
     * Add new distributor
     * @param body (optional) 
     * @return successful operation
     */
    addDistributor(body: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/distributors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDistributor(_response);
        });
    }

    protected processAddDistributor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            return throwException("unprocessable entity", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get countries that have distributors.
     * @param lang (optional) Send lang short code
     * @return successful operation
     */
    getDistributorCountries(lang: string | undefined): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/distributor-countries?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistributorCountries(_response);
        });
    }

    protected processGetDistributorCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Country[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(<any>null);
    }

    /**
     * Get countries by language.
     * @param lang (optional) Send lang short code
     * @return successful operation
     */
    getCountries(lang: string | undefined): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/countries?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Country[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(<any>null);
    }

    /**
     * Get distributor sectors. If not existing, get awards for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getDistributorSectors(lang: string | undefined): Promise<DistributorSector[]> {
        let url_ = this.baseUrl + "/api/distributor-sectors?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistributorSectors(_response);
        });
    }

    protected processGetDistributorSectors(response: Response): Promise<DistributorSector[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DistributorSector[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistributorSector[]>(<any>null);
    }

    /**
     * Get category events. If not existing, get events for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getAllEventCategoryItems(lang: string | undefined): Promise<EventCategory[]> {
        let url_ = this.baseUrl + "/api/event-categories?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEventCategoryItems(_response);
        });
    }

    protected processGetAllEventCategoryItems(response: Response): Promise<EventCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EventCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventCategory[]>(<any>null);
    }

    /**
     * Get events. If not existing, get events for default language.
     * @param lang (optional) Send language short code
     * @param category (optional) Send category slug
     * @param pageQuery (optional) Send page number
     * @param limitQuery (optional) Send limit per page
     * @return successful operation
     */
    getAllEventsItems(lang: string | undefined, category: string | undefined, pageQuery: number | undefined, limitQuery: number | undefined): Promise<EventResource> {
        let url_ = this.baseUrl + "/api/events?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (pageQuery === null)
            throw new Error("The parameter 'pageQuery' cannot be null.");
        else if (pageQuery !== undefined)
            url_ += "page=" + encodeURIComponent("" + pageQuery) + "&";
        if (limitQuery === null)
            throw new Error("The parameter 'limitQuery' cannot be null.");
        else if (limitQuery !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limitQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEventsItems(_response);
        });
    }

    protected processGetAllEventsItems(response: Response): Promise<EventResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EventResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventResource>(<any>null);
    }

    /**
     * Get event by slug for selected language.If language does not exist, get event for default language
     * @param lang (optional) Send language short code
     * @param slug Send event slug
     * @return successful operation
     */
    getOneEvent(lang: string | undefined, slug: string): Promise<Event> {
        let url_ = this.baseUrl + "/api/events/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOneEvent(_response);
        });
    }

    protected processGetOneEvent(response: Response): Promise<Event> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Event>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Event>(<any>null);
    }

    /**
     * Get highlighted events. If not existing, get highlighted events for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getHighlightedEventsItems(lang: string | undefined): Promise<Event[]> {
        let url_ = this.baseUrl + "/api/events/highlighted/events?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHighlightedEventsItems(_response);
        });
    }

    protected processGetHighlightedEventsItems(response: Response): Promise<Event[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Event[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Event[]>(<any>null);
    }

    /**
     * Get events. If not existing, get events for default language.
     * @param lang (optional) Send language short code
     * @param category (optional) Send category slug
     * @param pageQuery (optional) Send page number
     * @param limitQuery (optional) Send limit per page
     * @return successful operation
     */
    getAllEventsItemsForHomeSlider(lang: string | undefined, category: string | undefined, pageQuery: number | undefined, limitQuery: number | undefined): Promise<EventResource> {
        let url_ = this.baseUrl + "/api/events/home/slider?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (pageQuery === null)
            throw new Error("The parameter 'pageQuery' cannot be null.");
        else if (pageQuery !== undefined)
            url_ += "page=" + encodeURIComponent("" + pageQuery) + "&";
        if (limitQuery === null)
            throw new Error("The parameter 'limitQuery' cannot be null.");
        else if (limitQuery !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limitQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEventsItemsForHomeSlider(_response);
        });
    }

    protected processGetAllEventsItemsForHomeSlider(response: Response): Promise<EventResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EventResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventResource>(<any>null);
    }

    /**
     * Get galleries. If not existing, get awards for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getGalleries(lang: string | undefined): Promise<GalleryResource> {
        let url_ = this.baseUrl + "/api/galleries?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGalleries(_response);
        });
    }

    protected processGetGalleries(response: Response): Promise<GalleryResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GalleryResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GalleryResource>(<any>null);
    }

    /**
     * Get gallery by slug for selected language.
         *     If language does not exist, get event for default language
     * @param lang (optional) Send language short code
     * @param slug Send gallery slug
     * @return successful operation
     */
    getOneGallery(lang: string | undefined, slug: string): Promise<Gallery> {
        let url_ = this.baseUrl + "/api/galleries/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOneGallery(_response);
        });
    }

    protected processGetOneGallery(response: Response): Promise<Gallery> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Gallery>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gallery>(<any>null);
    }

    /**
     * Get landing pages. If not existing, get awards for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getLandingPages(lang: string | undefined): Promise<LandingPage[]> {
        let url_ = this.baseUrl + "/api/landing-pages?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLandingPages(_response);
        });
    }

    protected processGetLandingPages(response: Response): Promise<LandingPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LandingPage[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LandingPage[]>(<any>null);
    }

    /**
     * Get Landing Page. If not existing, get landing page for default language.
     * @param lang (optional) Send language short code
     * @param slug Send page slug
     * @return successful operation
     */
    getLendingPage(lang: string | undefined, slug: string): Promise<LandingPage> {
        let url_ = this.baseUrl + "/api/landing-pages/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLendingPage(_response);
        });
    }

    protected processGetLendingPage(response: Response): Promise<LandingPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LandingPage>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LandingPage>(<any>null);
    }

    /**
     * Get all available languages.
     * @return successful operation
     */
    getAllLanguages(): Promise<Language[]> {
        let url_ = this.baseUrl + "/api/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllLanguages(_response);
        });
    }

    protected processGetAllLanguages(response: Response): Promise<Language[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Language[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language[]>(<any>null);
    }

    /**
     * Get language according to IP address.
     * @return successful operation
     */
    getGeoLanguages(): Promise<Language> {
        let url_ = this.baseUrl + "/api/languages/geo-language";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGeoLanguages(_response);
        });
    }

    protected processGetGeoLanguages(response: Response): Promise<Language> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Language>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language>(<any>null);
    }

    /**
     * Get menus for the language. If not existing, get menus for default language.
     * @param lang (optional) Send language short code
     * @param position (optional) Send Position (footer, header)
     * @return successful operation
     */
    getMenus(lang: string | undefined, position: string | undefined): Promise<Menu> {
        let url_ = this.baseUrl + "/api/menus?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMenus(_response);
        });
    }

    protected processGetMenus(response: Response): Promise<Menu> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Menu>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Menu>(<any>null);
    }

    /**
     * Get menus items for the language. If not existing, get items for default language.
     * @param lang (optional) Send language short code
     * @param position (optional) Send Position (footer, header)
     * @return successful operation
     */
    getMenuItems(lang: string | undefined, position: string | undefined): Promise<MenuItem[]> {
        let url_ = this.baseUrl + "/api/menus/menu-items?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMenuItems(_response);
        });
    }

    protected processGetMenuItems(response: Response): Promise<MenuItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MenuItem[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuItem[]>(<any>null);
    }

    /**
     * Get menus socials for the language. If not existing, get socials for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getMenuSocials(lang: string | undefined): Promise<Social[]> {
        let url_ = this.baseUrl + "/api/menus/socials?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMenuSocials(_response);
        });
    }

    protected processGetMenuSocials(response: Response): Promise<Social[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Social[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Social[]>(<any>null);
    }

    /**
     * Get mixes for selected language. If language is does not exist, get mixes for default language.
     * @param lang (optional) Send language short code
     * @param page (optional) Send page number
     * @param limit (optional) Send limit per page
     * @return successful operation
     */
    getMixes(lang: string | undefined, page: number | undefined, limit: number | undefined): Promise<MixResource> {
        let url_ = this.baseUrl + "/api/mixes?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMixes(_response);
        });
    }

    protected processGetMixes(response: Response): Promise<MixResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MixResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MixResource>(<any>null);
    }

    /**
     * Get mix by slug for selected language. If language does not exist, get mix for default language.
     * @param lang (optional) Send language short code
     * @param slug Send mix slug
     * @return successful operation
     */
    getSingleMix(lang: string | undefined, slug: string): Promise<SingleMix> {
        let url_ = this.baseUrl + "/api/mixes/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleMix(_response);
        });
    }

    protected processGetSingleMix(response: Response): Promise<SingleMix> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SingleMix>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SingleMix>(<any>null);
    }

    /**
     * Get mix for home page for selected lang. If language does not exist, get mix for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getHomePageMix(lang: string | undefined): Promise<Mix> {
        let url_ = this.baseUrl + "/api/mixes/highlighted/home?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHomePageMix(_response);
        });
    }

    protected processGetHomePageMix(response: Response): Promise<Mix> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Mix>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mix>(<any>null);
    }

    /**
     * Get news categories. If not existing, get news categories for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getAllNewsCategories(lang: string | undefined): Promise<NewsCategory[]> {
        let url_ = this.baseUrl + "/api/news-categories?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllNewsCategories(_response);
        });
    }

    protected processGetAllNewsCategories(response: Response): Promise<NewsCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NewsCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsCategory[]>(<any>null);
    }

    /**
     * Get highlighted news for language. If not existing, get highlighted news for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getHighlightedNews(lang: string | undefined): Promise<SingleNews[]> {
        let url_ = this.baseUrl + "/api/news/highlighted/news?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHighlightedNews(_response);
        });
    }

    protected processGetHighlightedNews(response: Response): Promise<SingleNews[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SingleNews[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SingleNews[]>(<any>null);
    }

    /**
     * Get news for language. If not existing, get news for default language.
     * @param lang (optional) Send language short code
     * @param category (optional) Send category slug
     * @param page (optional) Send page number
     * @param limit (optional) Send limit per page
     * @return successful operation
     */
    getNews(lang: string | undefined, category: string | undefined, page: number | undefined, limit: number | undefined): Promise<NewsResource> {
        let url_ = this.baseUrl + "/api/news?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNews(_response);
        });
    }

    protected processGetNews(response: Response): Promise<NewsResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NewsResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsResource>(<any>null);
    }

    /**
     * Get news by slug for selected language. If language does not exist, get mix for default language.
     * @param lang (optional) Send language short code
     * @param slug Send news slug
     * @return successful operation
     */
    getSingleNews(lang: string | undefined, slug: string): Promise<SingleNews> {
        let url_ = this.baseUrl + "/api/news/{slug}?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleNews(_response);
        });
    }

    protected processGetSingleNews(response: Response): Promise<SingleNews> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SingleNews>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SingleNews>(<any>null);
    }

    /**
     * Subscribe user to newsletter
     * @param body (optional) 
     * @return successful operation
     */
    subscribe(body: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/newsletters/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            return throwException("unprocessable entity", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get all pages for selected lang. If not existing, get for deafult language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getPages(lang: string | undefined): Promise<Page[]> {
        let url_ = this.baseUrl + "/api/pages?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPages(_response);
        });
    }

    protected processGetPages(response: Response): Promise<Page[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Page[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Page[]>(<any>null);
    }

    /**
     * Submit order
     * @param body (optional) 
     * @return successful operation
     */
    submitOrder(body: any | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/api/shop/order/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitOrder(_response);
        });
    }

    protected processSubmitOrder(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Order>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(<any>null);
    }

    /**
     * Get all products from the shop
     * @param lang (optional) Send language short code
     * @param page (optional) Send page number
     * @param limit (optional) Send limit per page
     * @return successful operation
     */
    getAllProducts(lang: string | undefined, page: number | undefined, limit: number | undefined): Promise<ProductResource> {
        let url_ = this.baseUrl + "/api/products?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProducts(_response);
        });
    }

    protected processGetAllProducts(response: Response): Promise<ProductResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResource>(<any>null);
    }

    /**
     * Get product from the shop by given product Code
     * @param lang (optional) Send language short code
     * @param code Send product code
     * @return successful operation
     */
    getProduct(lang: string | undefined, code: string): Promise<ProductResource> {
        let url_ = this.baseUrl + "/api/products/{code}?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduct(_response);
        });
    }

    protected processGetProduct(response: Response): Promise<ProductResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductResource>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResource>(<any>null);
    }

    /**
     * Manipulate reservation
     * @param body (optional) 
     * @return successful operation
     */
    reservation(body: any | undefined): Promise<Reservation> {
        let url_ = this.baseUrl + "/api/shop/reservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReservation(_response);
        });
    }

    protected processReservation(response: Response): Promise<Reservation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Reservation>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Reservation>(<any>null);
    }

    /**
     * Delete reservation
     * @param body (optional) 
     * @return successful operation
     */
    reservationDelete(body: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/shop/reservation/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReservationDelete(_response);
        });
    }

    protected processReservationDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get timeline-years. If not existing, get timeline-years for default language.
     * @param lang (optional) Send language short code
     * @return successful operation
     */
    getTimelineYears(lang: string | undefined): Promise<TimelineYear[]> {
        let url_ = this.baseUrl + "/api/timeline-years?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimelineYears(_response);
        });
    }

    protected processGetTimelineYears(response: Response): Promise<TimelineYear[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TimelineYear[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimelineYear[]>(<any>null);
    }
}

export interface ImageMeta {
    /** Base64 image representation */
    base64: string;
    responsive: ResponsiveImage[];
    /** Thumb url */
    thumb: string;
}

export interface VideoMeta {
    /** Thumb url */
    thumb: string;
}

export interface Video {
    video: string;
}

export interface ResponsiveImage {
    width: number;
    height: number;
    image: string;
}

export interface PaginationLinks {
    first: string;
    last: string;
    prev: string;
    next: string;
}

export interface PaginationMeta {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export interface AwardResource {
    award_items: Award[];
    links: PaginationLinks;
    meta: PaginationMeta;
}

export interface Award {
    /** Award location */
    location: string;
    /** Award name */
    name: string;
    /** Award date */
    date: string;
    /** Award image */
    image: string;
    image_meta: ImageMeta;
}

export interface MakeOrder {
    /** Reservation ID */
    reservation_id?: string;
    /** Delivery type (Customer or Company) */
    delivery_type?: string;
    /** Firstname */
    firstname?: string;
    /** Lastname */
    lastname?: string;
    /** Email address */
    email?: string;
    /** Delivery address */
    address1?: string;
    /** Delivery Alternative address */
    address2?: string;
    /** Delivery postal number */
    postal?: string;
    /** City */
    city?: string;
    /** Telephone */
    telephone?: string;
    /** Company */
    company?: string;
    /** Company PIB number */
    pib?: string;
    /** Company registration number */
    registration_number?: string;
}

export interface Order {
    /** Base Order ID */
    order_id?: string;
    /** Base Order Total */
    total?: number;
    /** Base Order Total Currency */
    currency?: string;
    products?: BaseProduct[];
    delivery?: Delivery_company;
}

export interface BaseProduct {
    /** Product code */
    code: string;
    /** Product Name */
    name: string;
    /** Product Image */
    media: string;
    /** Product integer */
    price: number;
    /** Product Price currency */
    currency: string;
    /** Ordered Product Quantity */
    quantity: number;
    /** Ordered Product Cost For The Given Qauntity */
    cost: number;
}

export interface Delivery_customer {
    /** Delivery (Customer or Company) */
    delivery_type: string;
    /** First Name */
    firstname: string;
    /** Last Name */
    lastname: string;
    /** Email */
    email: string;
    /** Phone number */
    telephone: string;
    /** Delivery address */
    address1: string;
    /** Delivery Alternative Address */
    address2: string;
    /** Postal number */
    postal: number;
    /** City */
    city: string;
}

export interface Delivery_company {
    /** Delivery (Customer or Company) */
    delivery_type: string;
    /** First Name */
    firstname: string;
    /** Last Name */
    lastname: string;
    /** Email */
    email: string;
    /** Phone number */
    telephone: string;
    /** Delivery address */
    address1: string;
    /** Delivery Alternative Address */
    address2: string;
    /** Postal number */
    postal: number;
    /** City */
    city: string;
    /** Company PIB number */
    pib: string;
    /** Company Registration Number */
    registration_number: string;
    /** Company Name */
    company: string;
}

export interface PageComponent {
    /** Component tag */
    tag: string;
    /** Component title */
    title: string;
    /** Component position */
    position: string;
    /** Component description */
    description: string;
    /** Component button_text */
    button_text: string;
    /** Component button_url */
    button_url: string;
    /** Component button_url_type */
    button_url_type: string;
    /** Component image */
    image: string;
    image_meta: ImageMeta;
}

export interface VideoContent {
    /** Content name */
    name: string;
    /** content_type */
    content_type: string;
    /** Content image */
    video: string;
    video_meta: VideoMeta;
}

export interface ImageContent {
    /** Content name */
    name: string;
    /** content_type */
    content_type: string;
    /** Content alt */
    alt: string;
    /** Content image */
    image: string;
    image_meta: ImageMeta;
}

export interface TextContent {
    /** Content name */
    name: string;
    /** content_type */
    content_type: string;
    /** Content content */
    content: string;
    /** Text content type */
    text_type: string;
}

export interface RichTextContent {
    /** Content name */
    name: string;
    /** content_type */
    content_type: string;
    /** Content content */
    content: string;
}

export interface Country {
    /** Country name */
    name: string;
    /** Country code */
    code: string;
}

export interface Department {
    /** Department name */
    name: string;
    /** Department slug */
    slug: string;
}

export interface Distributor {
    /** Distributor name */
    name: string;
    /** Distributor sector */
    sector: string;
    /** Distributor address */
    address: string;
    /** Distributor city */
    city: string;
    /** Distributor country */
    country: string;
    /** Distributor customer number */
    customer_number: string;
    /** Distributor website */
    website: string;
    /** Distributor email */
    email: string;
    /** Distributor phone */
    phone: string;
    /** Distributor reference */
    reference: string;
    /** Distributor lang */
    lang: string;
}

export interface DistributorSector {
    /** Distributor Sector name */
    name: string;
    /** Distributor Sector slug */
    slug: string;
}

export interface EventResource {
    event_items: Event[];
    links: PaginationLinks;
    meta: PaginationMeta;
}

export interface Event {
    /** Event date */
    date: string;
    /** Event author */
    author: string;
    /** Event post date */
    post_date: string;
    /** Event name */
    name: string;
    /** Event description */
    description: string;
    /** Event place */
    place: string;
    /** Event address link */
    link_address: string;
    /** Event address link type */
    link_address_type: string;
    /** Event slug */
    slug: string;
    /** Event link */
    link_event: string;
    /** Event link type */
    link_event_type: string;
    /** Event category name */
    category_name: string;
    /** Event category_slug */
    category_slug: string;
    /** Event image */
    image: string;
    image_meta: ImageMeta;
    meta_data?: MetaData;
    content?: Content[];
}

export interface EventCategory {
    /** Event category name */
    name: string;
    /** Event category slug */
    slug: string;
}

export interface GalleryResource {
    gallery_items: Gallery[];
}

export interface Images {
    /** Gallery image */
    image: string;
    responsive?: ImageMeta;
    /** Thumb url */
    thumb?: string;
}

export interface Gallery {
    /** Gallery name */
    name: string;
    /** Gallery slug */
    slug: string;
    images: Images;
}

export interface LandingPage {
    /** Landing Page name */
    name: string;
    /** Landing Page slug */
    slug: string;
    content?: Content[];
}

export interface Language {
    /** Language name */
    name: string;
    /** Language native name */
    native_name: string;
    /** Language short code */
    short: string;
}

export enum MenuItemType {
    Internal = "internal",
    External = "external",
}

export interface Menu {
    menu_items: MenuItem[];
    socials: Social[];
    languages: Language[];
}

export interface MenuItem {
    /** Title */
    title: string;
    /** Slug */
    slug: string;
    /** Href */
    href: string;
    /** Show on Header */
    header: boolean;
    /** Show on Footer */
    footer: boolean;
    /** Menu Item Type */
    type: string;
}

export interface MetaData {
    /** Meta title */
    title: string;
    /** Meta keywords */
    keywords: string;
    /** Meta description */
    description: string;
    image: MetaDataImage;
}

export interface MetaDataImage {
    /** Image width */
    width: number;
    /** Image height */
    height: number;
    /** Image location */
    image: string;
}

export interface MixResource {
    mix_items: Mix[];
    links: PaginationLinks;
    meta: PaginationMeta;
}

export interface Mix {
    /** Mix title */
    title: string;
    /** Mix slug */
    slug: string;
    /** Mix category */
    category: string;
    /** Mix summary */
    summary: string;
    /** Mix image */
    image: string;
    image_meta: ImageMeta;
    /** Mix video */
    video?: string;
    video_meta?: VideoMeta;
}

export interface SingleMix {
    /** Single mix title */
    title: string;
    /** Single mix slug */
    slug: string;
    /** Single mix category */
    category: string;
    /** Single mix summary */
    summary: string;
    /** Single mix image */
    image: string;
    image_meta: ImageMeta;
    /** Single mix image */
    video?: string;
    video_meta?: VideoMeta;
    meta_data?: MetaData;
    /** Single mix description */
    description?: string;
    /** Single mix tag */
    tag?: string;
    steps?: MixStep[];
}

export interface MixStep {
    /** Mix step title */
    title: string;
    /** Mix step number */
    number: number;
    /** Mix step description */
    description: string;
    /** Award image */
    image: string;
    image_meta: ImageMeta;
}

export interface NewsResource {
    news_items: SingleNews[];
    links: PaginationLinks;
    meta: PaginationMeta;
}

export interface SingleNews {
    /** News title */
    title: string;
    /** News tag */
    tag: string;
    /** News summary */
    summary: string;
    /** News slug */
    slug: string;
    categories: NewsCategory[];
    /** News image */
    image: string;
    image_meta: ImageMeta;
    meta_data?: MetaData;
    content?: Content[];
}

export interface NewsCategory {
    /** News category name */
    name: string;
    /** News category slug */
    slug: string;
}

export interface Page {
    /** Name */
    name: string;
    /** Slug */
    slug: string;
    /** Href */
    href: string;
    meta_data: MetaData;
}

export interface ProductResource {
    product_items: Product[];
    links: PaginationLinks;
    meta: PaginationMeta;
}

export interface Product {
    /** Product label */
    label: string;
    /** Price of the product */
    price: string;
    /** Stock of the product */
    stock: number;
    /** Product image */
    image: string;
    /** Product name */
    name: string;
    /** Short Description of the product */
    summary: string;
    /** Long description of the product */
    description: string;
    /** Page where pruduct will be shown */
    show_on_page?: string;
}

export interface Reservation {
    /** Reservation id */
    reservation_id?: string;
    products: ReservationProduct[];
}

export interface ReservationProduct {
    product_id: string;
    quantity: string;
}

export interface Social {
    /** Social name */
    name: string;
    /** Social url */
    url: string;
    /** Menu Item Type */
    type: string;
}

export interface TimelineYear {
    /** TimelineYear year */
    year: number;
    /** TimelineYear url */
    tag: string;
    /** TimelineYear title */
    title: string;
    /** TimelineYear description */
    description: string;
    /** Award image */
    image: string;
    image_meta: ImageMeta;
}

export interface Contact {
    /** Name */
    name: string;
    /** Email address */
    email: string;
    /** Message subject */
    subject: string;
    /** Message body */
    message: string;
    /** Department slug */
    department_slug: string;
}

export interface DistributorRequest {
    /** Language short code */
    lang: string;
    /** Distributor's email address */
    email: string;
    /** Distributor's name */
    name: string;
    /** Sector */
    sector: string;
    /** Number of customers */
    customer_number?: number;
    /** Distributor's country */
    country?: string;
    /** Distributor's references */
    reference?: string;
}

export interface Subscriber {
    /** Subscriber's email address */
    email?: string;
    /** Language short code */
    lang?: string;
}

export interface ReservationDelete {
    /** Reservation id */
    reservation_id?: string;
}

export interface Content {
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}